<div class="one" fxLayout="column" [formGroup]="MatterPropertyDetailsForm">
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="100"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.PARISH),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PARISH),
      }"
    >
      <!-- <mat-select formControlName="PARISH" matTooltip="{{(toolTipList)?toolTipList.PARISH?.HOVER:''}}"
      [matTooltipPosition]="toolTipPostion">
      <mat-option *ngFor="let ParishLookupDataVal of ParishLookupData"
        value="{{ParishLookupDataVal.LOOKUPGUID}}">
      {{ParishLookupDataVal.LOOKUPFULLVALUE}}</mat-option>
    </mat-select> -->

      <mat-label>Parish</mat-label>
      <input
        matInput
        formControlName="PARISH"
        [matAutocomplete]="auto"
        matTooltip="{{ toolTipList ? toolTipList.PARISH?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        (keyup.enter)="parishDetectChanges($event, 'Parish')"
        (keyup)="parishDetectChanges($event, 'Parish')"
      />
      <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
        @for (ParishLookupDataVal of filteredOptions; track ParishLookupDataVal) {
          <mat-option
            value="{{ ParishLookupDataVal.LOOKUPFULLVALUE }}"
            (click)="setId(ParishLookupDataVal, 'Parish')"
          >
            {{ ParishLookupDataVal.LOOKUPFULLVALUE }}
          </mat-option>
        }
      </mat-autocomplete>

      @if (testBool && toolTipList.PARISH) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.PARISH.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.PARISH?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" class="pr-1">
    <mat-form-field
      appearance="outline"
      fxFlex="100"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.LOCALITY),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.LOCALITY),
      }"
    >
      <!-- <mat-label>Locality </mat-label> -->
      <!-- <input matInput formControlName="LOCALITY"> -->
      <!-- <mat-select formControlName="LOCALITY" matTooltip="{{(toolTipList)?toolTipList.LOCALITY?.HOVER:''}}"
      [matTooltipPosition]="toolTipPostion">
      <mat-option *ngFor="let LocalityLookupDataVal of LocalityLookupData"
        value="{{LocalityLookupDataVal.LOOKUPGUID}}">
      {{LocalityLookupDataVal.LOOKUPFULLVALUE}}</mat-option>
    </mat-select> -->

      <mat-label>Locality</mat-label>
      <input
        matInput
        formControlName="LOCALITY"
        [matAutocomplete]="auto1"
        matTooltip="{{ toolTipList ? toolTipList.LOCALITY?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        (keyup.enter)="parishDetectChanges($event, 'Locality')"
        (keyup)="parishDetectChanges($event, 'Locality')"
      />
      <mat-autocomplete autoActiveFirstOption #auto1="matAutocomplete">
        @for (LocalityLookupDataVal of LocalityFilteredOptions; track LocalityLookupDataVal) {
          <mat-option
            value="{{ LocalityLookupDataVal.LOOKUPFULLVALUE }}"
            (click)="setId(LocalityLookupDataVal, 'Locality')"
          >
            {{ LocalityLookupDataVal.LOOKUPFULLVALUE }}
          </mat-option>
        }
      </mat-autocomplete>

      @if (testBool && toolTipList.LOCALITY) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.LOCALITY.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.LOCALITY?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" class="pr-1">
    <mat-form-field
      appearance="outline"
      fxFlex="100"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.COUNCIL),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.COUNCIL),
      }"
    >
      <!-- <mat-label>Council</mat-label> -->
      <!-- <input matInput formControlName="COUNCIL"> -->
      <!-- <mat-select formControlName="COUNCIL" matTooltip="{{(toolTipList)?toolTipList.COUNCIL?.HOVER:''}}"
      [matTooltipPosition]="toolTipPostion">
      <mat-option *ngFor="let CouncilLookupsDataVal of CouncilLookupsData"
        value="{{CouncilLookupsDataVal.LOOKUPGUID}}">
      {{CouncilLookupsDataVal.LOOKUPFULLVALUE}}</mat-option>
    </mat-select> -->

      <mat-label>Council</mat-label>
      <input
        matInput
        formControlName="COUNCIL"
        [matAutocomplete]="auto2"
        matTooltip="{{ toolTipList ? toolTipList.COUNCIL?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        (keyup.enter)="parishDetectChanges($event, 'Council')"
        (keyup)="parishDetectChanges($event, 'Council')"
      />
      <mat-autocomplete autoActiveFirstOption #auto2="matAutocomplete">
        @for (CouncilLookupsDataVal of CouncilFilteredOptions; track CouncilLookupsDataVal) {
          <mat-option
            value="{{ CouncilLookupsDataVal.LOOKUPFULLVALUE }}"
            (click)="setId(CouncilLookupsDataVal, 'Council')"
          >
            {{ CouncilLookupsDataVal.LOOKUPFULLVALUE }}
          </mat-option>
        }
      </mat-autocomplete>

      @if (testBool && toolTipList.COUNCIL) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.COUNCIL.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.COUNCIL?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="50"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.COUNCILPROPERTYNUMBER),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.COUNCILPROPERTYNUMBER),
      }"
    >
      <mat-label>Council Property No</mat-label>
      <input
        matInput
        formControlName="COUNCILPROPERTYNUMBER"
        matTooltip="{{ toolTipList ? toolTipList.COUNCILPROPERTYNUMBER?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      @if (testBool && toolTipList.COUNCILPROPERTYNUMBER) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.COUNCILPROPERTYNUMBER.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.COUNCILPROPERTYNUMBER?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="50"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.SPI),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.SPI),
      }"
    >
      <mat-label>SPI</mat-label>
      <input
        matInput
        name="SPI"
        formControlName="SPI"
        matTooltip="{{ toolTipList ? toolTipList.SPI?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      @if (testBool && toolTipList.SPI) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.SPI.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.SPI?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
</div>
